import { render } from "./BbPlayerGrid.vue?vue&type=template&id=676196f4&scoped=true"
import script from "./BbPlayerGrid.vue?vue&type=script&lang=js"
export * from "./BbPlayerGrid.vue?vue&type=script&lang=js"

import "./BbPlayerGrid.vue?vue&type=style&index=0&id=676196f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676196f4"]])

export default __exports__